import { ConfigConstants, MatSerNumber, NotificationIdentifier } from '@evorait/pace-core';
import { initialNotificationIdentifier } from '../store/state/notification-identifier.state';
import { FormIdentifier } from './form-identifier';
import { FormsConstants } from './forms-constants';

export type FormList = Readonly<{
    materialId: string;
    equipmentId: string;
    country: string;
    notification: NotificationIdentifier;
    notificationType: ConfigConstants.NotificationTypes;
    isLoading: boolean;
    loaded: boolean; // indicates if successful loading happened at least once
    entries: FormListEntryState[];
    downloadingAll: boolean;
    equipmentSet: MatSerNumber[];
    selectedLanguage: FormsConstants.FORM_LANGUAGES;
}>;

export type FormListEntryState = Readonly<{
    id: FormIdentifier;
    lockedBy: string;
    type: FormsConstants.FORMTYPE;
    typeLabel: string;
    title: string;
    variant: string;
    loadStatus: FormsConstants.LOAD_STATUS;
    submitStatus: FormsConstants.SUBMIT_STATUS;
    cached: boolean;
    isOldVersion: boolean;
    deviceId: string;
    deviceType: string;
    previousSubmit: boolean;
}>;

export const initialFormListState: FormList = {
    materialId: '',
    equipmentId: '',
    country: '',
    notification: initialNotificationIdentifier,
    notificationType: ConfigConstants.NotificationTypes.Unknown,
    isLoading: false,
    loaded: false,
    entries: [],
    downloadingAll: false,
    equipmentSet: [],
    selectedLanguage: FormsConstants.FORM_LANGUAGES.English,
};

export type FormListEntryWithNotificationState = FormListEntryState &
    Readonly<{
        notificationId: NotificationIdentifier;
    }>;
